import actionTypes from "../../actions/actionTypes";

const initialState = {
  addCSVUploadLoader: false,
  getPasswordExpiryLoader: false,
  setPasswordExpiryLoader: false,
  getUserEmailDetailsLoader: false,
  addUserEmailDetailsLoader: false,
};

const organizationSettingsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.adminTypes.organizationSettingTypes.SET_UPLOAD_CSV_LOADER:
      return {
        ...state,
        addCSVUploadLoader: payload,
      };
    case actionTypes.adminTypes.organizationSettingTypes
      .GET_PASSWORD_EXPIRY_LOADER:
      return {
        ...state,
        getPasswordExpiryLoader: payload,
      };
    case actionTypes.adminTypes.organizationSettingTypes
      .SET_PASSWORD_EXPIRY_LOADER:
      return {
        ...state,
        setPasswordExpiryLoader: payload,
      };
    case actionTypes.adminTypes.organizationSettingTypes
      .GET_USER_EMAIL_DETAILS_LOADER:
      return {
        ...state,
        getUserEmailDetailsLoader: payload,
      };
    case actionTypes.adminTypes.organizationSettingTypes
      .ADD_USER_EMAIL_DETAILS_LOADER:
      return {
        ...state,
        addUserEmailDetailsLoader: payload,
      };
    default:
      return state;
  }
};

export default organizationSettingsReducer;
